import { GridCellParams, GridRowParams } from "@mui/x-data-grid";
import { Record } from "../../components/record/Record";
import { bankTransactionsSearchSettings, treatmentsSearchSettings } from "../../utils/createSearchFilter";
import { OrderHeader } from "./OrderHeader";
import { IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { formatCurrency } from "../../utils/formatCurrency";
import { GridPreview } from "../../components/gridPreview/GridPreview";
import { OrdersDetail } from "./OrdersDetail";
import { DisassociateOrderButton } from "../bank-transactions/OrdersAssociatedRecords/DisassociateOrderButton";
import { OpenInNew } from "@mui/icons-material";

export const fieldsQuery = "*.*,order.treatment.client.*,order.treatment.client.user_id.*,order.clinic.*";

export const ordersPaymentsOptions = {
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "order.treatment",
                createFilter: (params: any) => treatmentsSearchSettings(params),
            },
            {
                field: "connected_bank_transaction_id",
                charactersLimit: 20,
                createFilter: (params: any) => bankTransactionsSearchSettings(params),
            },
        ],
    },
    dataGridOptions: {
        extraColumns: {
            beggining: [
                {
                    headerName: "Preview",
                    field: "preview",
                    width: 75,
                    renderCell: (params: GridCellParams) => {
                        return (
                            <GridPreview
                                key={params.id}
                                component={
                                    <Record
                                        idFromProps={params.row.order?.id}
                                        entity="orders"
                                        type="detail"
                                        fieldsQuery="*.*,client_id.user_id.*,treatment.client.*, treatment.client.user_id.*"
                                        header={<OrderHeader />}
                                        body={<OrdersDetail />}
                                    />
                                }
                            />
                        );
                    },
                },
                {
                    headerName: "Clínica",
                    field: "clinic",
                    width: 100,
                    renderCell: (params: GridCellParams) => {
                        return <Typography>{params.row.order?.clinic?.name}</Typography>;
                    },
                },
                {
                    headerName: "Valor",
                    field: "amount_display",
                    width: 100,
                    renderCell: (params: GridCellParams) => {
                        return <Typography>{formatCurrency(params.row.amount)}</Typography>;
                    },
                },
            ],
            end: [],
        },
    },
    fieldsToRemove: {
        fieldNamesToRemove: ["id", "order"],
        fieldTypesToRemove: [],
    },
    extraOptions: {
        sort: "-payment_date",
    },
};

const navigateToOrderDetail = (params: GridRowParams) => {
    const order = params.row?.order;
    const orderId = typeof order === "object" ? order?.id : order;
    return orderId ? `/orders/${orderId}/detail` : `/orders_payments/${params.id}/detail`;
};

export const bankTransactionsOrdersPaymentsOptions = {
    dataGridOptions: {
        navigateToDetail: navigateToOrderDetail,
        extraColumns: {
            beggining: [
                {
                    headerName: "Ver Compra",
                    field: "view_order",
                    width: 120,
                    renderCell: (params: GridCellParams) => {
                        const order = params.row?.order;
                        const orderId = typeof order === "object" ? order?.id : order;

                        if (!orderId) return null;

                        return (
                            <IconButton
                                sx={{ p: 0 }}
                                onClick={(e) => e.stopPropagation()}
                                color="secondary"
                                component={Link}
                                to={`/orders/${orderId}/detail`}
                                target="_blank"
                            >
                                <OpenInNew />
                            </IconButton>
                        );
                    },
                },
                {
                    headerName: "Clínica",
                    field: "clinic",
                    width: 100,
                    renderCell: (params: GridCellParams) => {
                        return <Typography>{params.row.order?.clinic?.name}</Typography>;
                    },
                },
            ],
            end: [
                {
                    headerName: "Ações",
                    field: "actions",
                    width: 130,
                    sortable: false,
                    renderCell: (params: GridCellParams) => <DisassociateOrderButton params={params} />,
                    },
                ],
            },
    },
};
